import { useParams, Link } from "react-router-dom";
import noticias from "../data/noticias";

const NoticiaDetalle = () => {
  const { id } = useParams();
  const noticia = noticias.find((n) => n.id === parseInt(id));

  if (!noticia) {
    return (
      <div className="container mx-auto px-4 py-10">
        <h2 className="text-2xl text-red-600">Noticia no encontrada</h2>
        <Link to="/noticias" className="text-blue-600 underline">
          Volver a noticias
        </Link>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-10">
      <div className="mb-6">
        <Link
          to="/noticias"
          className="text-sm text-white bg-[#202C5A] px-4 py-2 rounded hover:bg-[#1a234b]"
        >
          ← Volver a todas las noticias
        </Link>
      </div>

      <img
        src={noticia.imagen}
        alt={noticia.titulo}
        className="w-full max-h-[500px] object-contain rounded mb-6 shadow"
      />

      <div className="mb-4 flex items-center gap-4">
        <span className="bg-[#FF69B4] text-white text-xs px-3 py-1 uppercase rounded">
          {noticia.categoria}
        </span>
        <span className="text-gray-600 text-sm">{noticia.fecha}</span>
      </div>

      <h1 className="text-3xl font-bold text-[#202C5A] mb-6">{noticia.titulo}</h1>

    <div
  className="text-lg text-gray-800 leading-relaxed"
  dangerouslySetInnerHTML={{ __html: noticia.contenido }}
/>

    </div>
  );
};

export default NoticiaDetalle;
